




















































import { Vue, Component, Prop } from 'vue-property-decorator';
import BasePopper from '../base-popper/_base-popper.vue';
import BaseIcon from '../base-icon/_base-icon.vue';
import gaClickOutside from '../../directives/ga-click-outside';
import { EIconSize } from '../base-icon';

@Component({
  name: 'BaseDropdown',
  components: {
    BasePopper,
    BaseIcon,
  },
  data: () => ({
    EIconSize,
  }),
  directives: {
    gaClickOutside,
  },
})
export default class BaseDropdown extends Vue {
  @Prop({ default: () => [0, 0] }) offset: [number, number];
  @Prop({ default: false }) sameWidthAsRef: boolean;
  @Prop({ default: true }) closable: boolean;
  @Prop({ default: 'bottom-start' }) placement: string;
  @Prop({ default: false }) appendToBody: boolean;
  @Prop({ default: true }) closeOnAction: boolean;
  @Prop({ default: false }) disableToggle: boolean;
  @Prop({ default: true }) displayMobile: boolean;

  open = false;
  isScrolling = false;
  scrollTimeout = null;

  handleClick(event: Event) {
    if (this.disableToggle) {
      this.open = true;
      return;
    }
    this.open = !this.open;
    this.$emit('click', event);
  }

  handleKeyUpEnter(event: KeyboardEvent) {
    if (this.disableToggle) {
      this.open = true;
      return;
    }
    if (!this.open) {
      this.open = true;
      this.$emit('key-enter', event);
    } else {
      this.open = false;
      this.$emit('select', event);
    }
  }

  handleKeyUpDown(event: KeyboardEvent) {
    if (this.open) {
      this.$emit('key-down', event);
    }
    this.open = true;
  }

  handleKeyUpUp(event: KeyboardEvent) {
    if (this.open) {
      this.$emit('key-up', event);
    }
    this.open = true;
  }

  handleKeyUpEsc(event: KeyboardEvent) {
    this.open = false;
    this.$emit('key-esc', event);
  }

  handleContentClick() {
    if (this.closeOnAction) {
      this.open = false;
    }
  }
  handleHide() {
    this.open = false;
    this.$emit('hide');
  }

  handleScroll() {
    if (!this.isScrolling) {
      this.$emit('scroll-start');
    }

    clearTimeout(this.scrollTimeout);
    this.isScrolling = true;

    this.scrollTimeout = setTimeout(() => {
      this.$emit('scroll-end');
      this.isScrolling = false;
    }, 100);
  }
}
